{
    "NextrunningatLabel": "Next Running At:",
    "LastrunatLabel": "Last Run At:",
    "StatuserrorLabel": "Status / Error:",
    "NAME": "ScheduleStatus",
    "ScheduleStatus_SectionHeader": "Scheduling Status"
}